import { SVGInterface } from "../../interface";

const Lake = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 3L20.3301 13.5H17V15H22V17H2V15H7V11.874C5.27477 11.4299 4 9.86384 4 8C4 5.79086 5.79086 4 8 4C10.2091 4 12 5.79086 12 8C12 9.86384 10.7252 11.4299 9 11.874V15H15V13.5H11.6699L16 3ZM14.6581 11.5L16 8.24595L17.3419 11.5H14.6581ZM6 8C6 6.89543 6.89543 6 8 6C9.10457 6 10 6.89543 10 8C10 9.10457 9.10457 10 8 10C6.89543 10 6 9.10457 6 8Z"
      fill={color || "#0E171F"}
    />
    <path
      d="M12.1687 18.133C12.9362 18.7552 15.1783 20.5728 18.67 18C20.5 19.35 21.34 19.37 22 19.37V21.37C20.84 21.37 19.7 21.05 18.67 20.44C16.61 21.66 14.06 21.66 12 20.44C9.94 21.66 7.39 21.66 5.33 20.44C4.3 21.05 3.16 21.37 2 21.37V19.37L2.04005 19.37C2.68237 19.3706 3.46886 19.3714 5.33 18C8.80026 20.5541 10.9945 18.8007 11.8256 18.1365C11.8926 18.083 11.9508 18.0366 12 18C12.0446 18.0324 12.101 18.0781 12.1687 18.133Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default Lake;
